<template>
  <div class="voucher-code">
    <div class="voucher-code__ticket-icon">
      <BlIconAv name="ico_eticket" color="#3A5FD6" />
    </div>
    <BlTextAv variation="body-14">Kode voucher</BlTextAv>
    <div class="flex gap-3 mt-4 mb-12 items-center">
      <BlTextAv variation="subheading-18" weight="medium" data-testid="voucher-code">{{ voucherCode }}</BlTextAv>
      <BlIconAv name="ico_duplicate" class="h-5 w-5 cursor-pointer" data-testid="copy-voucher-code" @click.native="handleCopyButton" />
    </div>
    <BlButtonAv v-if="redeemUrl" variation="primary" :href="redeemUrl" data-testid="redeem-url">Tukar sekarang</BlButtonAv>
    <BlTextAv variation="caption-12" class="mt-12" data-testid="max-redeem-date">Batas penukaran: {{ formattedMaxRedeemAt }}</BlTextAv>
  </div>
</template>

<script>
import {BlTextAv, BlButtonAv} from '@bukalapak/bazaar-mweb-latest';
import {BlIconAv} from '@bukalapak/bazaar-visual';

export default {
  name: 'VoucherCode',
  components: {
    BlIconAv,
    BlTextAv,
    BlButtonAv,
  },
  props: {
    transactionDetail: {
      type: Object,
      required: true,
    },
  },
  computed: {
    voucherCode() {
      return this.transactionDetail?.voucher_code || '';
    },
    redeemUrl() {
      return this.transactionDetail?.merchant?.redeem_url || '';
    },
    formattedMaxRedeemAt() {
      if (!this.transactionDetail?.maximum_redeemed_at) return '-';
      const date = new Date(this.transactionDetail?.maximum_redeemed_at);
      const options = {timeZone: 'Asia/Jakarta', year: 'numeric', month: 'long', day: 'numeric'};
      const formattedDate = date.toLocaleDateString('id-ID', options);
      const formattedTime = date.toLocaleTimeString('id-ID', {timeZone: 'Asia/Jakarta', hour: '2-digit', minute: '2-digit'});
      return `${formattedDate}, ${formattedTime} WIB`;
    },
  },
  methods: {
    async handleCopyButton() {
      let element = document.createElement('input');
      document.body.appendChild(element);
      element.setAttribute('value', this.voucherCode);
      element.select();
      document.execCommand('copy');
      document.body.removeChild(element);
      this.$store.dispatch('onSnackbarShow', {message: 'Kode voucher berhasil disalin'});
    },
  },
};
</script>

<style lang="scss" scoped>
.voucher-code {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &__ticket-icon {
    padding: 12px;
    background-color: #ebf2fa;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    margin-bottom: 4px;
  }
}
</style>
